import { useEffect, useState } from 'react'

const STORAGE_KEY = 'farmula-theme'
const THEME_EVENT = 'farmula-theme'

export type Theme = 'light' | 'dark'

function currentTheme(): Theme {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

export function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
  try {
    localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    // Ignore storage access errors (private mode, etc).
  }
  window.dispatchEvent(new Event(THEME_EVENT))
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => (typeof document === 'undefined' ? 'light' : currentTheme()))

  useEffect(() => {
    const sync = () => setTheme(currentTheme())
    window.addEventListener(THEME_EVENT, sync)
    return () => window.removeEventListener(THEME_EVENT, sync)
  }, [])

  const toggle = () => {
    applyTheme(theme === 'dark' ? 'light' : 'dark')
  }

  return { theme, toggle }
}
